<template>
    <div class="driverList">
      <div class="content-container">
        <div class="titieMian">
          <div class="title-container">司机管理</div>
          <div class="select-container">
            <div class="select-container-box">
              <span>类型</span>
              <el-select v-model="type" filterable  size="small">
                <el-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="select-container-box">
              <span>输入查询</span>
              <el-input
                placeholder="请输入关键字"
                v-model="keyWord"
                :maxlength="num"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                size="small"
                class="search-input"
                clearable>
              </el-input>
            </div>
            <div class="select-container-box">
              <el-button size="small"  type="info" plain  class="query" @click="search()">查询</el-button>
              <el-button size="small"  type="info" plain @click="add()" class="add" style="background:#FF812D" v-if="edit">添加</el-button>
            </div>  
          </div>
        </div>  
        <div class="table-container">
          <el-table
            :data="driverList.list"
            style="width:100%"
            size="medium"
            @row-dblclick="dataBackFillGoods"
            :default-sort = "{prop: 'date', order: 'descending'}">
            <i slot="empty" style="font-style:normal">该时间段暂无数据</i>
            <el-table-column
              type="index"
              width="120"
              align="center"
              label="序号"
              >
            </el-table-column>
              <el-table-column
              prop="name"
              label="司机姓名"
              show-overflow-tooltip
              align="center"
              >
            </el-table-column>
            <el-table-column
              prop="carNo"
              label="车牌号"
              align="center"
              show-overflow-tooltip
              >
            </el-table-column>
            <el-table-column
              prop="driverNo"
              align="center"
              label="道路运输证"
          >
            </el-table-column>
          
            <el-table-column
              prop="phone"
              align="center"
              label="联系电话"
              >
            </el-table-column>
            <el-table-column label="操作" align="center" >
              <template slot-scope="scope">
                <span
                  class="content-edit"
                  v-if="edit"
                  @click="handleEdit(scope.$index, scope.row)">编辑</span>
                <span
                  class="content-del"
                  v-if="edit"
                  @click="handleDelete(scope.$index, scope.row)">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <page-change :pageInfo="pageInfo"></page-change>
      </div>
    </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import PageChange from "../../common/PageChange";
import mixins from "@/common/MixIn.js";
export default {
  name: "driverList",
  mixins: [mixins],
  components: {
    PageChange
  },
  data() {
    return {
      num: 20,
      type: "",
      typeList: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "name",
          label: "司机姓名"
        },
        {
          value: "carNo",
          label: "车牌号"
        },
        {
          value: "driverNo",
          label: "道路运输证"
        }
      ],

      keyWord: "", //查找
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      }
    };
  },
  computed: {
    ...mapState(modules.driverManage, ["driverList"])
  },
  async mounted() {
    await this.initPagePermission();
    this.search();
  },
  methods: {
    ...mapActions(modules.driverManage, [
      "getDriverData", //查询数据
      "delDriver" //删除数据
    ]),
    //查询
    search(pageNum) {
      let obj = {
        pageIndex: (this.pageInfo.pageNumber = pageNum || 1),
        pageSize: this.pageInfo.pageSize,
        carNo: this.carNo,
        name: this.name,
        driverNo: this.driverNo
      };
      if (this.type === "") {
        obj.name = this.keyWord;
        obj.carNo = this.keyWord;
        obj.driverNo = this.keyWord;
      } else {
        obj[this.type] = this.keyWord;
      }
      this.getDriverData(obj)
        .then(rsp => {
          if (rsp.status === 200) {
            this.pageInfo.totalPages = rsp.data.total;
          }
        })
        .catch(err => {
          console.dir(err);
        });
    },
    //双击进入编辑页面
    dataBackFillGoods(row, event) {
      this.$router.push({
        name: "editDriver",
        query: { id: row.id }
      });
    },
    //添加
    add() {
      this.$router.push({
        name: "addDriver"
      });
    },
    //编辑页面
    handleEdit(index, row) {
      this.$router.push({
        name: "editDriver",
        query: { id: row.id }
      });
    },
    //删除
    handleDelete(index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await this.delDriver(row.id);
          this.search(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error(err.response.data);
        });
    }
  }
};
</script>

<style lang="stylus" scoped>
  .driverList .content-container .titieMian .select-container{
    margin-top:-5px; 
  }
</style>
